import React, { useContext, useEffect, useState } from 'react'
import { DContext } from '../../context/Datacontext'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchGetUsers, updateUsers } from '../services/fetchGetUser'
import { fetchManager } from '../services/fetchManager'
import { fetchTeamLead } from '../services/fetchTeamLead'
import InputRegister from '../blocks/ui/InputDesign'
import placeholder from '../../assets/profile picture.png'
import { confirmPasswordValidator, contactValidator, emailValidator, firstNameValidator, fullNameValidator, lastNameValidator, passwordValidator } from '../../utils/validator'
import { compressImage } from '../../utils/compressImages'
import { renderImgSrc } from '../../utils/renderImage'


export default function UpdateUsers() {

    const { BeURL, currentUser, showAlert } = useContext(DContext)
    const [users, setUsers] = useState(null)
    const { id } = useParams()
    const [errors, setErrors] = useState({ users: {} })
    const [password, setPassword] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    })

    const navigate = useNavigate()

    const [confirmChange, setConfirmChange] = useState(false)

    useEffect(() => {

        const fetchUser = async () => {
            await fetchGetUsers(BeURL, showAlert, setUsers, id)
        }
        fetchUser()
    }, [])


    const roleOptions = currentUser.role === "admin" ? ["manager", "teamlead", "recruiter"]
        : currentUser.role === "manager" ? ["teamlead", "recruiter"]
            : (currentUser.role === "superadmin") ? ["helpdesk", "admin", "manager", "teamlead", "recruiter"] :
                currentUser.role === "helpdesk" ? ["admin", "manager", "teamlead", "recruiter"] : [];

    // Reporting Mates
    const [reportingMates, setReportingMates] = useState({
        reportingManagerId: '',
        reportingTeamLeadIds: ''
    })

    const [managerIds, setManagerIds] = useState(null)
    const [teamleadIds, setTeamleadIds] = useState(null)

    useEffect(() => {
        if (users) {
            const rm = users.reportingManager || {};
            const tl = users.reportingTeamLead || {};

            setReportingMates({
                reportingManagerId: rm.reporingManagerId || "",
                reportingTeamLeadIds: tl.reportingTeamLeadId || ""
            });
        }
    }, [users]);


    useEffect(() => {
        const fetchManagers = async () => {
            if (currentUser.role === 'admin' && (users?.role === 'teamlead' || users?.role === 'recruiter')
            ) {
                await fetchManager(
                    currentUser.company.companyId, BeURL, showAlert, setManagerIds
                );
            }
        };

        fetchManagers();
    }, [currentUser.company.companyId, users?.role]);

    // Fetch Team Lead
    useEffect(() => {
        const fetchLeads = async () => {
            if (users?.role === 'recruiter' &&
                (currentUser.role === 'admin')) {
                await fetchTeamLead(currentUser.company.companyId, BeURL, showAlert,
                    reportingMates.reportingManagerId, setTeamleadIds
                );
            }

            if (users?.role === 'recruiter' &&
                (currentUser.role === 'manager')) {
                await fetchTeamLead(currentUser.company.companyId, BeURL, showAlert,
                    currentUser.id, setTeamleadIds
                );
            }
        };

        fetchLeads();
    }, [currentUser.company.companyId, reportingMates.reportingManagerId]);

    // Password Code :

    const handlePassword = (name, value) => {
        setPassword((prev) => ({ ...prev, [name]: value }));

        let errorMsg = '';
        switch (name) {
            case "currentPassword":
                errorMsg = passwordValidator(value);
                break;
            case "newPassword":
                errorMsg = passwordValidator(value);
                break;

            case "confirmPassword":
                errorMsg = confirmPasswordValidator(value, password.newPassword);
                break;

            default:
                break;
        }
        // Update error state
        setErrors((prev) => ({
            ...prev,
            users: {
                ...prev.users,
                [name]: errorMsg,
            },
        }));
    }
    // File Handle
    const [profileFile, setProfileFile] = useState(null);
    const [previewProfile, setPreviewProfile] = useState(users?.profilePicture || placeholder);

    const handleProfileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const compressed = await compressImage(file)

        setProfileFile(compressed);
        setPreviewProfile(URL.createObjectURL(compressed));
    };

    // Reporting Managers :

    const handleLeads = (name, values) => {
        setReportingMates((prev) => ({ ...prev, [name]: values }))
    }

    // Handle the inputs
    const handleusers = (name, value) => {
        // Update state with allowed patterns
        if (["firstName", "lastName", "fullName"].includes(name)) {
            if (/^[A-Za-z. ]*$/.test(value)) {
                setUsers((prev) => ({ ...prev, [name]: value }));
            }
        } else if (["contact", "alternateContact"].includes(name)) {
            if (/^[0-9]*$/.test(value)) {
                setUsers((prev) => ({ ...prev, [name]: value }));
            }
        } else if (name === 'role') {
            setUsers((prev) => ({ ...prev, [name]: value }));
            setReportingMates({
                reportingManagerId: '',
                reportingTeamLeadIds: ''
            })
        }
        else {
            setUsers((prev) => ({ ...prev, [name]: value }));
        }

        // Validation
        let errorMsg = '';
        switch (name) {
            case "firstName":
                errorMsg = firstNameValidator(value);
                break;

            case "fullName":
                errorMsg = fullNameValidator(value);
                break;

            case "lastName":
                if (value.trim()) errorMsg = lastNameValidator(value); // optional
                break;

            case "email":
                errorMsg = emailValidator(value);
                break;

            case "alternateEmail":
                if (value.trim()) errorMsg = emailValidator(value); // optional
                break;

            case "contact":
                errorMsg = contactValidator(value);
                break;

            case "alternateContact":
                if (value.trim()) errorMsg = contactValidator(value); // optional
                break;
            default:
                break;
        }
        // Update error state
        setErrors((prev) => ({
            ...prev,
            users: {
                ...prev.users,
                [name]: errorMsg,
            },
        }));

    };


    const isFormValid = (errors) => {
        // Check if all error objects are empty
        return (
            Object.values(errors.users || {}).every((err) => !err)
        )
    }

    const handleUpdate = () => {
        // Users
        const formData1 = new FormData()
        formData1.append('firstName', users.firstName)
        formData1.append('lastName', users.lastName)
        formData1.append('fullName', users.fullName)
        formData1.append('email', users.email)
        formData1.append('alternateEmail', users.alternateEmail)
        formData1.append('contact', users.contact)
        // formData1.append('reportingTeamLeadId', '')
        formData1.append('alternateContact', users.alternateContact)
        formData1.append('selectedRole', users.role)

        formData1.append('isEmployee', users?.isEmployee || false)

        if (users?.employementId) {
            formData1.append('empId', users.employementId)
        }
        // formData.append('reportingTeamLeadId', users.)

        if (password) {
            formData1.append('currentPassword', password.currentPassword)
            formData1.append('password', password.newPassword)
        }

        if (profileFile) {
            formData1.append('profile', profileFile)
        }

        if (currentUser.role === "admin") {

            if (["teamlead", "recruiter"].includes(users.role)) {
                if (reportingMates.reportingManagerId) {
                    formData1.append("reportingManagerId", reportingMates.reportingManagerId);
                }
            }

            if (users.role === "recruiter" && reportingMates.reportingTeamLeadIds) {
                formData1.append("reportingTeamLeadId", reportingMates.reportingTeamLeadIds);
            }
        }

        if (currentUser.role === "manager") {
            if (["teamlead", "recruiter"].includes(users.role)) {
                formData1.append("reportingManagerId", currentUser.id);
            }

            if (users.role === "recruiter" && reportingMates.reportingTeamLeadIds) {
                formData1.append("reportingTeamLeadId", reportingMates.reportingTeamLeadIds);
            }
        }

        if (currentUser.role === "teamlead") {
            if (users.role === "recruiter") {
                //  Fixed typo + added safety
                if (currentUser.reportingManager?.reportingManagerId) {
                    formData1.append(
                        "reportingManagerId",
                        currentUser.reportingManager.reportingManagerId
                    );
                }
                formData1.append("reportingTeamLeadId", currentUser.id);
            }
        }

        updateUsers(BeURL, showAlert, formData1, users.id, navigate)

    }
    return (
        <main className='px-4 md:px-8 lg:px-16 xl:px-24 py-10 '>
            <section>
                <div className=" rounded-lg shadow-lg px-6 py-2">

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">

                        <label className="inline">
                            <img
                                src={users?.profilePicture && !profileFile ? renderImgSrc(users?.profilePicture) : previewProfile}
                                alt="Profile Logo"
                                className="w-16 h-16 object-cover rounded-full border inline"
                            />
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleProfileChange}
                                className="hidden "
                            />
                            <span className='text-sm px-2 text-primary-300 font-medium'>Click and change the Profile</span>
                        </label>

                        {[
                            {
                                label: "First Name", name: "firstName", value: users?.firstName, error: errors.users?.firstName, mandatory: true,
                                required: true
                            },
                            { label: " Last Name", name: "lastName", value: users?.lastName, error: errors.users?.lastName, }
                        ].map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <InputRegister
                                    key={idx}
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}
                                    mandatory={field.mandatory}
                                    required={field.required}
                                    placeholder={field.label}
                                    type="text"
                                    className="min-w-full md:w-full"
                                    error={field.error}
                                    onChange={(e) =>
                                        handleusers(e.target.name, e.target.value)
                                    }
                                />
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">

                        {[
                            {
                                label: "Full Name", name: "fullName", value: users?.fullName, error: errors.users?.fullName, mandatory: true,
                                required: true
                            },
                            {
                                label: " Email", name: "email", value: users?.email, error: errors.users?.email, mandatory: true,
                                required: true
                            },
                            { label: " Alternate Email", name: "alternateEmail", value: users?.alternateEmail, error: errors.users?.alternateEmail },
                        ].map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <InputRegister
                                    key={idx}
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}
                                    mandatory={field.mandatory}
                                    required={field.required}
                                    placeholder={field.label}
                                    type="text"
                                    className="min-w-full md:w-full"
                                    error={field.error}
                                    onChange={(e) =>
                                        handleusers(e.target.name, e.target.value)
                                    }
                                />
                            </div>
                        ))}
                    </div>

                    <div className={`grid grid-cols-1 ${currentUser.role === 'teamlead' ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-4 mt-2`}>

                        {[
                            {
                                label: "Contact Number",
                                name: "contact",
                                value: users?.contact,
                                error: errors.users?.contact,
                                mandatory: true,
                                required: true
                            },
                            {
                                label: "Alternate Contact Number",
                                name: "alternateContact",
                                value: users?.alternateContact,
                                error: errors.users?.alternateContact
                            },
                            {
                                label: "Employement Id ", name: "employementId", value: users?.employementId,
                            }

                        ].map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <InputRegister
                                    key={idx}
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}
                                    mandatory={field.mandatory}
                                    required={field.required}
                                    placeholder={field.label}
                                    type="text"
                                    className="min-w-full md:w-full"
                                    error={field.error}
                                    onChange={(e) =>
                                        handleusers(e.target.name, e.target.value)
                                    }
                                />
                            </div>
                        ))}
                    </div>

                    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4 my-2`}>

                        {users?.role !== 'admin' && < div className={`pt-1 bg-gray-50 p-4 rounded-xl shadow-inner ${currentUser.role === 'teamlead' ? 'hidden' : 'block'} `}>
                            <label className="block text-sm font-medium text-gray-600 mb-1 mt-2">
                                Role<sup className="text-red-500 text-sm">*</sup>
                            </label>
                            <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
                               focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                onChange={(e) =>
                                    handleusers(e.target.name, e.target.value)
                                }
                                name='role'
                                value={users?.role}>
                                <option className='text-gray-500' disabled>Select Role</option>
                                {
                                    roleOptions.map((r, i) =>
                                    (

                                        <option value={r} key={i}>{r}</option>

                                    ))
                                }
                            </select>
                            {errors.users?.role && < p class="text-sm text-red-500 mt-1 hidden">Role is Required</p>}
                        </div>}

                        {
                            (currentUser.role === 'admin') && (users?.role === 'teamlead' || users?.role === 'recruiter') &&
                            <div className='pt-1 bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <label className="block text-sm font-medium text-gray-600 mb-1 mt-2">
                                    Reporting Manager<sup className="text-red-500 text-sm">*</sup>
                                </label>
                                <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                    onChange={(e) =>
                                        handleLeads(e.target.name, e.target.value)
                                    }
                                    name='reportingManagerId'
                                    value={reportingMates?.reportingManagerId}>
                                    <option className='text-gray-500' >Select Manager</option>

                                    {
                                        managerIds && managerIds.length > 0 && managerIds.map((manager, i) =>
                                        (
                                            <option value={manager.id} key={i}>{manager.fullName}</option>
                                        ))
                                    }
                                </select>
                                {!reportingMates.reportingManagerId && < p class="text-sm text-red-500 mt-1 hidden">Reporing Manager is Required</p>}
                            </div>

                        }

                        {(currentUser.role === 'admin' || currentUser.role === 'manager') && (users?.role === 'recruiter') &&

                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <label className="block text-sm font-medium text-gray-600 mb-1">
                                    Reporting Team Lead<sup className="text-red-500 text-sm">*</sup>
                                </label>
                                <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                    onChange={(e) =>
                                        handleLeads(e.target.name, e.target.value)
                                    }
                                    name='reportingTeamLeadIds'
                                    value={reportingMates?.reportingTeamLeadIds}>
                                    <option className='text-gray-500' >Select Team Lead</option>

                                    {
                                        teamleadIds && teamleadIds.length > 0 && teamleadIds.map((teamlead, i) =>
                                        (
                                            <option value={teamlead.id} key={i}>{teamlead.fullName}</option>
                                        ))
                                    }
                                </select>
                                {!reportingMates.reportingTeamLeadIds && < p class="text-sm text-red-500 mt-1 hidden">Reporing Team Lead is Required</p>}
                            </div>

                        }
                    </div>

                    {/* <div className={`flex items-center text-left gap-4 mt-2`}>
                        <input type='checkbox' className='' onChange={() => setConfirmChange(!confirmChange)} /><span className="block text-sm font-medium text-gray-600 mb-1">Change Password</span>
                        <input type="checkbox" name="id" value={users?.isEmployee} /><span className="block text-sm font-medium text-gray-600 mb-1">is Employee</span>
                    </div> */}

                    <div className="flex items-center gap-6 mt-2">

                        {/* Change Password */}
                        <label className="flex items-center gap-2 text-sm font-medium text-gray-600">
                            <input
                                type="checkbox"
                                checked={confirmChange}
                                onChange={() => setConfirmChange(!confirmChange)}
                            />
                            Change Password
                        </label>

                        {/* Is Employee */}
                        <label className="flex items-center gap-2 text-sm font-medium text-gray-600">
                            <input
                                type="checkbox"
                                checked={users?.isEmployee || false}
                                onChange={(e) =>
                                    setUsers({ ...users, isEmployee: e.target.checked })
                                }
                            />
                            Is Employee
                        </label>

                    </div>

                   

                    {confirmChange && <div className={`grid grid-cols-1  md:grid-cols-3 gap-4 mt-2`}>

                        {[
                            {
                                label: "Current Password", name: "currentPassword", value: password.currentPassword, error: errors.users?.currentPassword, mandatory: true, required: true
                            },
                            { label: "New Password ", name: "newPassword", value: password.newPassword, error: errors.users?.newPassword, mandatory: true, required: true }, ,
                            { label: "Confirm Password ", name: "confirmPassword", value: password.confirmPassword, error: errors.users?.confirmPassword, mandatory: true, required: true },

                        ].map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <InputRegister
                                    key={idx} empId
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}
                                    mandatory={field.mandatory}
                                    required={field.required}
                                    placeholder={field.label}
                                    type="password"
                                    className="min-w-full md:w-full"
                                    error={field.error}
                                    onChange={(e) =>
                                        handlePassword(e.target.name, e.target.value)
                                    }
                                /></div>)
                        )}
                    </div>
                    }

                    <div className="md:col-span-2 flex justify-end mt-4">
                        <button
                            type="submit"
                            disabled={!isFormValid(errors)}
                            className={`px-4 py-2 rounded ${isFormValid(errors)
                                ? "bg-primary-200 text-white hover:bg-primary-500"
                                : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                            onClick={handleUpdate}
                        >
                            Update Users
                        </button>
                    </div>

                </div>
            </section>
        </main >
    )
}
